module.exports = __webpack_public_path__ + "img/callenge.14017ee6.svg";